module.exports = __webpack_public_path__ + "static/media/iu_logo.e2c7a5ca.png";